import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import {some} from 'lodash';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import {Aux, COMMUNICATION_NOTIFICATION_OPTIONS, COMMUNICATION_TYPES_WITH_MARKETING_OPTIONS, COMMUNICATION_TYPES_WITH_RUN_COMMUNICATION_OPTIONS, ROLE_SuperUser} from "../../constants";
import { mustBeArray } from '../../utils/lib';


class CommunicationsView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      communications: props.communications ? props.communications : [],
      communicationTypes: [
        {value: 'Work Phone', label: 'Work Phone'},
        {value: 'Mobile Phone', label: 'Mobile Phone'},
        {value: 'Other Phone', label: 'Other Phone'},
        {value: 'Sms Phone', label: 'Sms Phone'},
        {value: 'Work Email', label: 'Work Email'},
        {value: 'Other Email', label: 'Other Email'}],
      selectedCommunication: null,      
    };
            
    this.handleSaveCommunication = this.handleSaveCommunication.bind(this);
    this.handleCancelCommunication = this.handleCancelCommunication.bind(this);
    this.handleNewCommunication = this.handleNewCommunication.bind(this);
    this.handleSelectCommunication = this.handleSelectCommunication.bind(this);
    this.handleCommunicationTypeFieldChange = this.handleCommunicationTypeFieldChange.bind(this);
    this.handleCommunicationFieldChange = this.handleCommunicationFieldChange.bind(this);
    this.validateCommunication = this.validateCommunication.bind(this);
    this.handleCommunicationDelete = this.handleCommunicationDelete.bind(this);
    this.getCurrentState = this.getCurrentState.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }

  handleCommunicationTypeFieldChange(val){
    let defaultCommunicationOptions = COMMUNICATION_TYPES_WITH_MARKETING_OPTIONS.includes(val) ?
      {} : {receiveMarketingNotification: false, receiveCompletedServiceNotification: false}
    this.setState({selectedCommunication: {...this.state.selectedCommunication, 
      communicationType: val, ...defaultCommunicationOptions}});
  }

  handleCommunicationFieldChange(e){
    let x = {...this.state.selectedCommunication};
    if(e.target.type==="checkbox"){
      x[`${e.target.name}`] = e.target.checked;
    } else {
      x[`${e.target.name}`] = e.target.value;
    }
    this.setState({selectedCommunication: x});
  }

  handleSaveCommunication() {
    let added = false;
    let communications = [...this.state.communications].map(x => {
      let returnVal = x;
      if (returnVal.id == this.state.selectedCommunication.id) {
        added = true;
        return this.state.selectedCommunication;
      }
      return returnVal;
    });
    if(!added){
      communications = [...this.state.communications, this.state.selectedCommunication];
    }
    if(this.props.onChange){
       this.props.onChange(communications);
    }
    this.setState({communications, selectedCommunication: null});
  }

  validateCommunication(){
    let {selectedCommunication, communications} = this.state;
    if(selectedCommunication){
      if(selectedCommunication.communicationType.includes('Email')){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!(re.test(selectedCommunication.detail)))
        {
          return {valid: false, error: 'Invalid email ' };
        }
      }
      if(selectedCommunication.communicationType.includes('Phone')){
        let re = /^\D*0(\D*\d){9}\D*$/;
        if (!(re.test(selectedCommunication.detail)))
        {
          return {valid: false, error: 'Invalid phone ' };
        }
      }

      if(selectedCommunication.id < 0 && some(communications, x => x.detail == selectedCommunication.detail && x.id != selectedCommunication.id)){
        return {valid: false, error: 'Communication details must be unique' };
      }

      if(selectedCommunication.detail.trim() == '' || selectedCommunication.communicationType == ''){
        return {valid: false, error: ''};
      }
    }
    return {valid: true, error: ''};
  }

  handleCancelCommunication(){
    this.setState({selectedCommunication: null});
  }

  handleNewCommunication() {
    let count = this.state.communications.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);
    this.setState({selectedCommunication: {id: (-1 - count), communicationType: '', detail: '', 
    receiveCompletedServiceNotification: false, receiveMarketingNotification: false}});
  }

  handleCommunicationDelete(c){
    let communications = this.state.communications.filter(x => x.id != c.id);
    if(this.props.onChange){
      this.props.onChange(communications);
    }
    this.setState({communications});
  }

  handleSelectCommunication(ev, communication) {
    ev.preventDefault();
    this.setState({selectedCommunication: communication});
  }

  getCurrentState(){
    if(this.state.selectedCommunication){
      let valid = this.validateCommunication();
      if(valid.valid){
        this.handleSaveCommunication();
        return this.state.communications;
      } else {
        toastr.error(`Communication not complete - ${valid.error}`);
        return null;
      }
    }
    return this.state.communications;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.communications) !== JSON.stringify(this.props.communications)){
      this.setState({communications: this.props.communications});
    }
  }

  getColumns() {
    return [
      {
        accessor: 'communicationType',
        Header: 'Type',
        maxWidth: 110,
      }, {
        id: 'detail',
        Header: 'Detail',
        accessor: c => (<a href="#" onClick={(e)=>this.handleSelectCommunication(e, c)} >{c.detail}</a>),        
      },
      {
        id: 'isPrimary',
        Header: 'Primary',
        accessor: x => (<i className={`fa ${x.isPrimary ? 'fa-check' : 'fa-times'}`}/>),
        maxWidth: 75,
      },
      {
        id: 'updated',
        Header: 'Updated',
        accessor: c => c.id > 0 ? moment(c.updatedDate ? c.updatedDate : c.createdDate).format("DD/MM/YYYY h:mm:ss a") : '',
        maxWidth: 175,
      },
      {
        accessor: 'updatedBy',
        Header: 'Updated By',
      },
      {
        id: 'delete',
        Header: '',
        accessor: c => (<Button color="danger" onClick={() => this.handleCommunicationDelete(c)}><i className="fa fa-times" /></Button>),
        maxWidth: 60,
      }
    ];
  } 

  render() {
    const isValidCommunication = this.validateCommunication();
    let {communications, selectedCommunication} = this.state;
    return (
        <div style={{marginBottom: '20px'}}>
          <div className="form-group row" style={{marginLeft: '0px'}}>
            <h6>
              Communications&nbsp;<Button color="success" onClick={this.handleNewCommunication}><i
                className="fa fa-plus"/>&nbsp;&nbsp;Add communication</Button>
            </h6>
          </div>
          {selectedCommunication ?
              (<Aux>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label" htmlFor="communicationType">Type</label>
                  <div className="col-md-4">
                    <Select
                        name="communicationType"
                        value={this.state.selectedCommunication.communicationType}
                        multi={false}
                        simpleValue={true}
                        options={this.state.communicationTypes}
                        onChange={this.handleCommunicationTypeFieldChange}
                        delimiter=", "
                        clearable={false}
                        deleteRemoves={false}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label" htmlFor="detail">Detail</label>
                  <div className="col-md-8">
                    <Input
                        maxLength={`${this.state.selectedCommunication.communicationType.includes('Email') ? '100' : '15'}`}
                        value={this.state.selectedCommunication.detail}
                        onChange={this.handleCommunicationFieldChange}
                        name="detail"
                        placeholder="Detail"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label" htmlFor="detail">Is Primary</label>
                  <div className="col-md-8">
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox"
                               className="checkbox-control"
                               checked={this.state.selectedCommunication.isPrimary}
                               onChange={this.handleCommunicationFieldChange}
                               name="isPrimary"
                        />
                      </Label>
                    </FormGroup>
                  </div>
                </div>
                {
                  COMMUNICATION_TYPES_WITH_MARKETING_OPTIONS.includes(this.state.selectedCommunication.communicationType) &&
                  <React.Fragment>
                    <div className="form-group row">
                      <label className="col-md-2 form-control-label" htmlFor="receiveCompletedServiceNotification">Receive Completed Collection/Delivery/Removal Notification</label>
                      <div className="col-md-8">
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox"
                                  className="checkbox-control"
                                  checked={this.state.selectedCommunication.receiveCompletedServiceNotification}
                                  onChange={this.handleCommunicationFieldChange}
                                  name="receiveCompletedServiceNotification"
                            />
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 form-control-label" htmlFor="receiveMarketingNotification">Receive Marketing Notication</label>
                      <div className="col-md-8">
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox"
                                  className="checkbox-control"
                                  checked={this.state.selectedCommunication.receiveMarketingNotification}
                                  onChange={this.handleCommunicationFieldChange}
                                  name="receiveMarketingNotification"
                            />
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                  </React.Fragment>
                }
                <div className="form-group row">
                  <div className="offset-md-2 col-md-8">
                    {isValidCommunication.valid ?
                        <Button color="primary" onClick={this.handleSaveCommunication} style={{marginRight: '10px'}}><i
                            className="fa fa-check"/>&nbsp;
                        </Button> :
                        <span className="text-danger">{isValidCommunication.error}</span>
                    }
                    <Button color="secondary" onClick={this.handleCancelCommunication}><i
                        className="fa fa-mail-reply"/>&nbsp;</Button>
                  </div>
                </div>
              </Aux>)
              :
              (<ReactTable
                  sortable={false}
                  filterable={false}
                  showPagination={false}
                  data={communications}
                  columns={this.getColumns()}
                  minRows={2}
              />)}
        </div>
    );
  }
}

CommunicationsView.propTypes = {
  communications: PropTypes.array.isRequired,
  onChange: PropTypes.func,
};

CommunicationsView.defatultProps = {
  communications: []
};

export default CommunicationsView;